import { SBadge } from './Badge.styles';
import { BadgeProps } from './Badge.types';

export const Badge = ({ ...props }: BadgeProps) => {
  return <SBadge {...props} />;
};
